module.exports = __webpack_public_path__ + "static/media/Card__exportData.a3325f64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Card__exportData.svg
// module id = 1100
// module chunks = 0